<div class="modal-header">
    <h4 class="modal-title" id="modal-title">{{title| translate}}</h4>
</div>
<div class="modal-body">
    <ng-content class="modal-section"></ng-content>
</div>
<div class="modal-footer justify-content">
	<div class="flex-start">
		<button type="button" class="btn btn-default" *ngIf="buttons.onCancel" id="cancel-dialog-btn" (click)="cancel()" aria-label="{{'winDialog.cancel'}}">{{'winDialog.cancel' | translate}}</button>
		<button type="button" class="btn btn-default" *ngIf="buttons.onClose" id="close-dialog-btn" (click)="close()" aria-label="{{'winDialog.closed'}}">{{'winDialog.close' | translate}}</button>
	</div>
    <div class="flex-end">
    	<button type="button" class="btn btn-primary" id="confirm-dialog-btn" *ngIf="buttons.onConfirm" (click)="confirm()"aria-label="{{'winDialog.confirm'}}">{{'winDialog.confirm'| translate}}</button>
    	<button type="button" class="btn btn-primary" id="save-dialog-btn" *ngIf="buttons.onSave" (click)="save()" aria-label="{{'winDialog.save'| translate}}">{{'winDialog.save'| translate}}</button>
	</div>
</div>